import styled from "styled-components";
import { space, color, layout, typography } from "styled-system";
import propTypes from "@styled-system/prop-types";
import { themeGet } from "@styled-system/theme-get";

const ButtonFilter = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0;
  height: 48px;
  width: 100%;
  border: 1px solid ${themeGet("colors.EYBlack.default")};
  background-color: ${themeGet("colors.EYYellow.default")};
  text-decoration: none;
  font-weight: ${themeGet("fontWeights.bold")};
  color: ${themeGet("colors.EYOffBlack.default")};
  cursor: pointer;
  ${space}
  ${color}
  ${layout}
  ${typography}

  &:hover {
    background-color: ${themeGet("colors.EYYellow.hover")};
  }
`;

ButtonFilter.displayName = `Button`;

ButtonFilter.defaultProps = {
  fontSize: "2",
};

ButtonFilter.propTypes = {
  ...propTypes.space,
  ...propTypes.color,
  ...propTypes.layout,
  ...propTypes.typography,
};

export { ButtonFilter };
